"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandaloneLog = void 0;
const logger_1 = require("./logger");
const logger_2 = require("./types/logger");
/**
 * Creates a standalone instance of `Logger` without an `EnvironmentManager`.
 *
 * @remarks
 * This logger is configured with:
 * - Default log level: `Info`
 * - Colors enabled for log messages
 * - No environment-specific configurations
 */
exports.StandaloneLog = new logger_1.Logger({
    destinations: [], // No destinations configured
    loggerOptions: { withColors: true }, // Logger options
    logLevel: logger_2.LogLevels.Info, // Default log level
});
//# sourceMappingURL=log.js.map